import { ActivityLogListFilters, ActivityLogState } from './types';

const defaultState: ActivityLogState = {
  selectedActivityLog: null,
  onSelectActivityLog: () => {},
  resetSelectedActivityLog: () => {},
  activityLogListFilters: { pageSize: 10, pageOffset: 0 },
  onActivityLogListFiltersChange: (filters: Partial<ActivityLogListFilters>) => {},
  activityLogListData: [],
  activityLogDetailsData: null,
  loadingState: {
    isLoadingActivityLogList: false,
    isLoadingActivityLogDetails: false,
  },
  errorState: {
    activityLogListDataError: undefined,
    activityLogDetailsError: undefined,
  },
  // activity log filter drawer default state
  isActivityLogFilterDrawerOpen: false,
  toggleActivityLogFilterDrawer: () => {},
};

export { defaultState };
